// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__33-VQ","userNavWrapper":"styles_userNavWrapper__1RtUY","userSubNavigation":"styles_userSubNavigation__7tkWG","userNavItem":"styles_userNavItem__3jCeZ"};